import solver from 'solver-utilities';
import { auth, close as closeAuth } from './auth.js';
import { cart, get as getCart, close as closeHeaderCart } from './cart.js';
import { collection, setcollectionGridHeight } from './collection.js';
import { dropdown } from './dropdown.js';
import { filters, autoOpenFilters } from './filters.js';
import { sort } from './sort.js';
import {
  header,
  mobile,
  setHeaderHeight,
  setHeaderLimit,
  setHeaderScrollYPosition,
  toggleHeaderLogo
} from './mega-menu.js';
import { keyup } from './keyboard-events.js';
import { loading } from './loading.js';
import { modal } from './modal.js';
import { newsletter } from './newsletter.js';
import { notification } from './notification.js';
import { onOutOfBounds } from './bounds.js';
import { onResize } from './resize.js';
import { onScroll } from './scroll.js';
import { pageSearch } from './page-search.js';
import { policies } from './policies.js';
import { product, setProductMedia, setPaginationMaxHeight } from './product.js';
import { returns } from './returns.js';
import { search, close as closeHeaderSearch } from './search.js';
import { sizeChart, close as closeSizeChart } from './size-chart.js';
import { store } from './store.js';
import { swiper } from './swiper.js';

window.onload = async function () {
  dayjs.extend(window.dayjs_plugin_utc);
  dayjs.extend(window.dayjs_plugin_timezone);

  console.log = function () {}; // Will prevent third party console logs
  console.clear();
  console.info('Init Scripts');

  loading(); // <!-- Must be first to intercept HTTP requests

  const isCartMenuActive = function (event) {
    const container = document.querySelector('[data-el="header-cart"]');
    const bounds = container.getBoundingClientRect();
    const limitX = bounds.x - 50;

    if (event.clientX < limitX && container.className.indexOf('animate__fadeInRight') > -1) {
      return true;
    }

    return false;
  };

  const isAuthActive = function (event) {
    const container = document.querySelector('[data-el="auth-container"]');
    const bounds = container.getBoundingClientRect();
    const limitX = bounds.x - 50;

    if (event.clientX < limitX && container.className.indexOf('animate__slideInRight') > -1) {
      return true;
    }

    return false;
  };

  const isSizeChartActive = function (event) {
    const container = document.querySelector('.size-chart__container');
    const bounds = container.getBoundingClientRect();
    const limitX = bounds.x - 50;

    if (
      event.clientX < limitX &&
      container.className.indexOf('size-chart__container--active') > -1
    ) {
      return true;
    }

    return false;
  };

  const isHeaderSearchActive = function (event) {
    const container = document.querySelector('.global-search-flyout');
    const search_container = document.querySelector('[data-el="global-search"]');
    const bounds = search_container.getBoundingClientRect();
    const limitY = bounds.bottom + 50;

    if (
      event.clientY > limitY &&
      container.className.indexOf('global-search-flyout--active') > -1 &&
      bounds.y >= 0
    ) {
      return true;
    }

    return false;
  };

  keyup({
    escape: function () {
      closeAuth();
      closeHeaderCart();
      closeHeaderSearch();
      closeSizeChart();
      mobile.close();
      (() => {
        const lists = document.querySelectorAll('.filter__list-items--active');

        if (!lists || (lists && !lists.length)) return;

        lists.forEach((list) => {
          list.classList.remove('filter__list-items--active');
        });
      })();
    }
  });

  onOutOfBounds([
    {
      trigger: isCartMenuActive,
      targetA: document.querySelector('[data-el="header-cart"]'),
      callback: closeHeaderCart
    },
    {
      trigger: isAuthActive,
      targetA: document.querySelector('[data-el="auth-container"]'),
      callback: closeAuth
    },
    {
      trigger: isSizeChartActive,
      targetA: document.querySelector('.size-chart__container'),
      callback: closeSizeChart
    },
    {
      trigger: isHeaderSearchActive,
      targetA: document.querySelector('[data-el="global-search"]'),
      callback: closeHeaderSearch
    }
  ]);

  onScroll([
    { callback: toggleHeaderLogo },
    { callback: setHeaderScrollYPosition },
    { callback: setHeaderHeight }
  ]);

  onResize([
    {
      xMin: 1100,
      trigger: setProductMedia,
      callback: setPaginationMaxHeight
    },
    {
      xMin: null,
      trigger: () => true,
      callback: setHeaderScrollYPosition
    },
    {
      xMin: null,
      trigger: () => null,
      callback: toggleHeaderLogo
    },
    {
      xMin: null,
      trigger: () => true,
      callback: setHeaderLimit
    },
    {
      xMin: null,
      trigger: () => true,
      callback: setHeaderHeight
    },
    {
      xMin: null,
      trigger: () => {
        return autoOpenFilters();
      },
      callback: () => document.body.classList.add('page--collection-filters')
    },
    {
      xMin: null,
      trigger: () => null,
      callback: setcollectionGridHeight
    }
  ]);

  await getCart();
  await product();

  auth();
  cart();
  dropdown();
  filters();
  sort();
  header();
  modal();
  newsletter();
  notification();
  pageSearch();
  policies();
  returns();
  search();
  sizeChart();
  store();
  swiper();

  document.body.classList.add('page--loaded');
  console.info('Scripts Ready');
};
